import { ThemeMode } from './enum'

export const dark = {
  title: ThemeMode.DARK,

  colors: {
    brandPrimary: '#f7f9fa',
    brandSecondary: '#f7f9fa',
    gray100: '#191c1f',
    gray200: '#282c2f',
    gray300: '#32363b',
    gray400: '#464b52',
    gray500: '#707780',
    gray600: '#9ea4ac',
    gray700: '#c9ced4',
    gray800: '#e6e9ed',
    gray900: '#f7f9fa',
    bgPrimary: '#0E1012',
    bgSecondary: '#282c2f',
    progressBg: '#ffffff',
    custom: {
      blue: {
        lightest: '#162C64',
        lighter: '#253F82',
        light: '#355CC0',
        normal: '#5981E3',
        dark: '#89A8F8',
        darker: '#BED1FF',
        darkest: '#F0F4FF'
      },
      cyan: {
        lightest: '#024242',
        lighter: '#066262',
        light: '#0A9090',
        normal: '#51C1C3',
        dark: '#7CDBDB',
        darker: '#A2EAEA',
        darkest: '#EDFFFF'
      },
      green: {
        lightest: '#003416',
        lighter: '#005122',
        light: '#006E2F',
        normal: '#009D43',
        dark: '#4ACC82',
        darker: '#99E9BB',
        darkest: '#EDFFF5'
      },
      pink: {
        lightest: '#72084E',
        lighter: '#9D1670',
        light: '#C31388',
        normal: '#D945A7',
        dark: '#D66CB2',
        darker: '#FFBDE9',
        darkest: '#FFEDF9'
      },
      purple: {
        lightest: '#260A81',
        lighter: '#4727B0',
        light: '#5A38C6',
        normal: '#7C5EE2',
        dark: '#AC93FC',
        darker: '#D3C6FD',
        darkest: '#F6F2FF'
      },
      orange: {
        lightest: '#511100',
        lighter: '#9C2100',
        light: '#C5310A',
        normal: '#EF4E23',
        dark: '#FE734F',
        darker: '#FF9377',
        darkest: '#FDECE7'
      },
      yellow: {
        lightest: '#453400',
        lighter: '#6C5200',
        light: '#A47C00',
        normal: '#EFBA0F',
        dark: '#FBD458',
        darker: '#F9E298',
        darkest: '#FFFAEB'
      },
      default: {
        lightest: '#282C2F',
        lighter: '#32363B',
        light: '#464B52',
        normal: '#707780',
        dark: '#9EA4AC',
        darker: '#C9CED4',
        darkest: '#E6E9ED'
      }
    }
  }
} as const
